

export class ToolTipHeaderStatusInput implements IToolTipHeaderStatusInput {
    /** The auto-generated id of the tool tip header master */
    tooltipHeaderId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IToolTipHeaderStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tooltipHeaderId = _data["tooltipHeaderId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ToolTipHeaderStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new ToolTipHeaderStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tooltipHeaderId"] = this.tooltipHeaderId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IToolTipHeaderStatusInput {
    /** The auto-generated id of the tool tip header master */
    tooltipHeaderId: number;
    /** The updated status */
    status: number;
}

